import { Box, Pagination, Typography } from '@mui/material';
import React from 'react';
import useScreenMode from '../../Hooks/useScreenMode';

type Props = {
    page: number;
    total: number;
    totalRows?: number;
    onPageChange: (page: number) => void;
    leftSlot?: React.ReactNode;
    rightSlot?: React.ReactNode;
    showTotalRows?: boolean;
};

export default function BolPagination({
    page,
    total,
    totalRows,
    onPageChange,
    leftSlot,
    rightSlot,
    showTotalRows = true,
}: Props) {
    const { isMobileLike } = useScreenMode();

    return (
        <Box
            sx={{
                px: 2,
                py: isMobileLike ? 0 : 1.5,
                border: '1px solid',
                borderColor: 'divider',
                borderRadius: 2,
                bgcolor: 'background.paper',
                display: 'flex',
                flexDirection: isMobileLike ? 'row' : 'row',
                alignItems: 'center',
                justifyContent: 'space-between',
                gap: 1.5,
                width: '100%',
            }}
        >
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1,
                    width: isMobileLike ? 'auto' : 'auto',
                    justifyContent: isMobileLike ? 'center' : 'flex-start',
                    flexWrap: 'wrap',
                }}
            >
                {leftSlot}
                {showTotalRows && typeof totalRows === 'number' ? (
                    <Typography variant="body2" color="text.secondary">
                        Total: {totalRows}
                    </Typography>
                ) : null}
            </Box>

            <Pagination
                page={page}
                count={Math.max(total, 1)}
                color="primary"
                siblingCount={isMobileLike ? 0 : 1}
                boundaryCount={isMobileLike ? 1 : 1}
                size={isMobileLike ? 'small' : 'medium'}
                onChange={(_, value) => onPageChange(value)}
            // sx={{ flexGrow: 1 }}
            />

            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1,
                    width: isMobileLike ? 'auto' : 'auto',
                    justifyContent: isMobileLike ? 'center' : 'flex-end',
                    flexWrap: 'wrap',
                }}
            >
                {rightSlot}
            </Box>
        </Box>
    );
}